import { createAnalyserLevelSource } from '@/features/audio/analyserLevel.ts';

/**
 * Live level of the interpreter's synthesized speech.
 *
 * The translator plays its audio from a saga, which has no way to hand a value
 * back to the view, so the saga publishes the live analyser here and
 * `TranslatorActive` reads it once per animation frame.
 */
export const translatorAiLevel = createAnalyserLevelSource();
